import { useModal } from "@pulse/hooks/contextHooks";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark } from "@fortawesome/sharp-regular-svg-icons";
import SecondaryModal from "./SecondaryModal";

function Modal() {
    const { visible, content, closeModal, closeOnClickedOutside } = useModal();

    if (!visible) return null;

    return (
        <>
            <div
                className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 px-2 py-2 backdrop-blur-[4px] transition-all duration-300 ease-in-out"
                onMouseDown={closeOnClickedOutside ? closeModal : undefined}
            >
                <div
                    className="flex max-h-[calc(100dvh-1rem)] max-w-full flex-col rounded-lg border border-gray-200 bg-white text-gray-800"
                    onMouseDown={(e) => e.stopPropagation()}
                >
                    <div
                        className={
                            content?.title
                                ? `flex w-full shrink-0 items-center justify-between border-b border-gray-200 p-4 text-2xl font-bold`
                                : `h-0 w-full shrink-0 p-2 text-right text-2xl`
                        }
                    >
                        {content?.title && <h1>{content.title}</h1>}
                        {!content?.disableXButton && (
                            <FontAwesomeIcon
                                icon={faXmark}
                                className="cursor-pointer opacity-70 hover:opacity-50 ml-2"
                                onClick={closeModal}
                                size="lg"
                            />
                        )}
                    </div>

                    <div className="flex min-h-0 flex-1 overflow-auto p-4">{content?.children}</div>
                </div>
            </div>
            <SecondaryModal />
        </>
    );
}

export default Modal;
